import canUseDom from '~/utils/can-use-dom'

export default canUseDom && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
